// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item-details-dialog {
  min-width: 500px;
  max-width: 600px;
  padding: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
@media (max-width: 768px) {
  .item-details-dialog {
    min-width: 90vw;
    max-width: 90vw;
  }
}

::ng-deep .mat-dialog-container {
  padding: 0 !important;
  overflow: hidden;
}
::ng-deep .item-details-dialog-container .mat-dialog-content {
  margin: 0;
  padding: 0;
}
::ng-deep .item-details-dialog-container .mat-dialog-actions {
  margin: 0;
  padding: 0;
}
::ng-deep .item-details-dialog .mat-dialog-content {
  padding: 20px 24px !important;
  box-sizing: border-box;
}
::ng-deep .item-details-dialog .dialog-actions .mat-button,
::ng-deep .item-details-dialog .dialog-actions .mat-raised-button {
  margin: 0 !important;
  line-height: 1 !important;
}

.dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid #e4e8f0;
}
.dialog-header h2 {
  margin: 0;
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 20px;
  font-weight: 600;
  color: #111827;
}
.dialog-header h2 .header-icon {
  color: #5ea1d8;
  font-size: 24px;
  width: 24px;
  height: 24px;
}
.dialog-header .close-button {
  color: #6b7280;
  width: 40px;
  height: 40px;
  min-width: 40px;
  min-height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  background: transparent;
  border: 1px solid transparent;
  padding: 0;
  margin: 0;
}
.dialog-header .close-button:hover {
  background: #f3f4f6;
  color: #374151;
  border-color: #e5e7eb;
}
.dialog-header .close-button:active {
  background: #e5e7eb;
  transform: scale(0.95);
}
.dialog-header .close-button mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  line-height: 20px;
}

.dialog-content {
  padding: 20px 24px !important;
  max-height: 60vh;
  overflow-y: auto;
  box-sizing: border-box;
}

.form-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 0;
  width: 100%;
  box-sizing: border-box;
}

.image-preview-section {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 8px;
}
.image-preview-section .item-preview-image {
  width: 100%;
  max-width: 300px;
  max-height: 200px;
  object-fit: contain;
  border-radius: 8px;
  border: 1px solid #e4e8f0;
  background: #f9fafb;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}
@media (max-width: 480px) {
  .form-row {
    grid-template-columns: 1fr;
  }
}

.full-width {
  width: 100%;
}

::ng-deep .item-details-dialog .mat-form-field {
  margin-bottom: 0;
  margin-top: 0;
  width: 100%;
}
::ng-deep .item-details-dialog .mat-form-field-wrapper {
  padding-bottom: 0;
  margin-bottom: 0;
}
::ng-deep .item-details-dialog .mat-form-field-appearance-outline .mat-form-field-infix {
  padding: 16px 14px !important;
  min-height: 56px;
}

.dialog-actions {
  padding: 20px 24px;
  border-top: 1px solid #e4e8f0;
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  align-items: center;
  margin: 0;
  min-height: 72px;
  box-sizing: border-box;
}
.dialog-actions button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 24px;
  font-size: 14px;
  font-weight: 500;
  height: 40px;
  min-width: 110px;
  border-radius: 6px;
  transition: all 0.2s ease;
  cursor: pointer;
  box-sizing: border-box;
  line-height: 1;
  white-space: nowrap;
  margin: 0;
}
.dialog-actions button mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  line-height: 18px;
}
.dialog-actions .cancel-btn {
  color: #6b7280;
  background: transparent;
  border: 1px solid #d1d5db;
}
.dialog-actions .cancel-btn:hover {
  background: #f9fafb;
  border-color: #9ca3af;
  color: #374151;
}
.dialog-actions .save-btn {
  background: #5ea1d8;
  color: white;
  border: 1px solid #5ea1d8;
}
.dialog-actions .save-btn:hover:not(:disabled) {
  background: #4a8fc4;
  border-color: #4a8fc4;
  box-shadow: 0 2px 4px rgba(94, 161, 216, 0.3);
}
.dialog-actions .save-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background: #9ca3af;
  border-color: #9ca3af;
}
@media (max-width: 768px) {
  .dialog-actions {
    padding: 16px;
    flex-direction: column-reverse;
    gap: 12px;
    min-height: auto;
  }
  .dialog-actions button {
    width: 100%;
    height: 44px;
    min-width: unset;
  }
}

.read-only-details {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  background-color: #f9fafb;
  border-radius: 8px;
  border: 1px solid #e4e8f0;
}
.read-only-details .detail-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.read-only-details .detail-field label {
  font-weight: 600;
  color: #6b7280;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.read-only-details .detail-field span {
  color: #111827;
  font-size: 14px;
  word-break: break-word;
}
.read-only-details .detail-field .item-link {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #5ea1d8;
  text-decoration: none;
  font-size: 14px;
  word-break: break-all;
}
.read-only-details .detail-field .item-link:hover {
  text-decoration: underline;
}
.read-only-details .detail-field .item-link mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}

:host-context(body.theme-dark) .item-details-dialog {
  background: #111827;
  color: #e2e8f0;
}
:host-context(body.theme-dark) .dialog-header {
  background: #111827;
  border-bottom-color: rgba(148, 163, 184, 0.15);
}
:host-context(body.theme-dark) .dialog-header h2 {
  color: #f1f5f9;
}
:host-context(body.theme-dark) .dialog-header .close-button {
  color: #94a3b8;
}
:host-context(body.theme-dark) .dialog-header .close-button:hover {
  background: #1f2937;
  border-color: rgba(148, 163, 184, 0.25);
  color: #e2e8f0;
}
:host-context(body.theme-dark) .dialog-header .close-button:active {
  background: #374151;
}
:host-context(body.theme-dark) .dialog-content {
  background: #111827;
}
:host-context(body.theme-dark) .read-only-details {
  background-color: #1f2937;
  border-color: rgba(148, 163, 184, 0.15);
}
:host-context(body.theme-dark) .read-only-details .detail-field label {
  color: #94a3b8;
}
:host-context(body.theme-dark) .read-only-details .detail-field span {
  color: #e2e8f0;
}
:host-context(body.theme-dark) .image-preview-section .item-preview-image {
  border-color: rgba(148, 163, 184, 0.2);
  background: #1f2937;
}
:host-context(body.theme-dark) .dialog-actions {
  background: #111827;
  border-top-color: rgba(148, 163, 184, 0.15);
}
:host-context(body.theme-dark) .dialog-actions .cancel-btn {
  color: #94a3b8;
  border-color: rgba(148, 163, 184, 0.3);
}
:host-context(body.theme-dark) .dialog-actions .cancel-btn:hover {
  background: #1f2937;
  border-color: rgba(148, 163, 184, 0.5);
  color: #e2e8f0;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/item-details-dialog/item-details-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AACF;AACE;EARF;IASI,eAAA;IACA,eAAA;EAEF;AACF;;AAGE;EACE,qBAAA;EACA,gBAAA;AAAJ;AAII;EACE,SAAA;EACA,UAAA;AAFN;AAKI;EACE,SAAA;EACA,UAAA;AAHN;AAQI;EACE,6BAAA;EACA,sBAAA;AANN;AAYM;;EAEE,oBAAA;EACA,yBAAA;AAVR;;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gCAAA;AAbF;AAeE;EACE,SAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAbJ;AAeI;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AAbN;AAiBE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,uBAAA;EACA,6BAAA;EACA,UAAA;EACA,SAAA;AAfJ;AAiBI;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AAfN;AAkBI;EACE,mBAAA;EACA,sBAAA;AAhBN;AAmBI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAjBN;;AAsBA;EACE,6BAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;AAnBF;;AAsBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,sBAAA;AAnBF;;AAsBA;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;AAnBF;AAqBE;EACE,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;AAnBJ;;AAuBA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AApBF;AAsBE;EALF;IAMI,0BAAA;EAnBF;AACF;;AAsBA;EACE,WAAA;AAnBF;;AAyBI;EACE,gBAAA;EACA,aAAA;EACA,WAAA;AAtBN;AAyBI;EACE,iBAAA;EACA,gBAAA;AAvBN;AA2BM;EACE,6BAAA;EACA,gBAAA;AAzBR;;AA+BA;EACE,kBAAA;EACA,6BAAA;EACA,aAAA;EACA,SAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,sBAAA;AA5BF;AA8BE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,sBAAA;EACA,cAAA;EACA,mBAAA;EACA,SAAA;AA5BJ;AA8BI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AA5BN;AAgCE;EACE,cAAA;EACA,uBAAA;EACA,yBAAA;AA9BJ;AAgCI;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AA9BN;AAkCE;EACE,mBAAA;EACA,YAAA;EACA,yBAAA;AAhCJ;AAkCI;EACE,mBAAA;EACA,qBAAA;EACA,6CAAA;AAhCN;AAmCI;EACE,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,qBAAA;AAjCN;AAqCE;EApEF;IAqEI,aAAA;IACA,8BAAA;IACA,SAAA;IACA,gBAAA;EAlCF;EAoCE;IACE,WAAA;IACA,YAAA;IACA,gBAAA;EAlCJ;AACF;;AAuCA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;AApCF;AAsCE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AApCJ;AAsCI;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;EACA,qBAAA;AApCN;AAuCI;EACE,cAAA;EACA,eAAA;EACA,sBAAA;AArCN;AAwCI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,qBAAA;EACA,eAAA;EACA,qBAAA;AAtCN;AAwCM;EACE,0BAAA;AAtCR;AAyCM;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAvCR;;AA+CE;EACE,mBAAA;EACA,cAAA;AA5CJ;AA+CE;EACE,mBAAA;EACA,8CAAA;AA7CJ;AA+CI;EACE,cAAA;AA7CN;AAgDI;EACE,cAAA;AA9CN;AAgDM;EACE,mBAAA;EACA,uCAAA;EACA,cAAA;AA9CR;AAiDM;EACE,mBAAA;AA/CR;AAoDE;EACE,mBAAA;AAlDJ;AAqDE;EACE,yBAAA;EACA,uCAAA;AAnDJ;AAsDM;EACE,cAAA;AApDR;AAuDM;EACE,cAAA;AArDR;AA0DE;EACE,sCAAA;EACA,mBAAA;AAxDJ;AA2DE;EACE,mBAAA;EACA,2CAAA;AAzDJ;AA2DI;EACE,cAAA;EACA,sCAAA;AAzDN;AA2DM;EACE,mBAAA;EACA,sCAAA;EACA,cAAA;AAzDR","sourcesContent":[".item-details-dialog {\n  min-width: 500px;\n  max-width: 600px;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n\n  @media (max-width: 768px) {\n    min-width: 90vw;\n    max-width: 90vw;\n  }\n}\n\n// Override Material Dialog defaults\n::ng-deep {\n  .mat-dialog-container {\n    padding: 0 !important;\n    overflow: hidden;\n  }\n\n  .item-details-dialog-container {\n    .mat-dialog-content {\n      margin: 0;\n      padding: 0;\n    }\n\n    .mat-dialog-actions {\n      margin: 0;\n      padding: 0;\n    }\n  }\n\n  .item-details-dialog {\n    .mat-dialog-content {\n      padding: 20px 24px !important;\n      box-sizing: border-box;\n    }\n  }\n\n  .item-details-dialog {\n    .dialog-actions {\n      .mat-button,\n      .mat-raised-button {\n        margin: 0 !important;\n        line-height: 1 !important;\n      }\n    }\n  }\n}\n\n.dialog-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 24px;\n  border-bottom: 1px solid #e4e8f0;\n\n  h2 {\n    margin: 0;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    font-size: 20px;\n    font-weight: 600;\n    color: #111827;\n\n    .header-icon {\n      color: #5ea1d8;\n      font-size: 24px;\n      width: 24px;\n      height: 24px;\n    }\n  }\n\n  .close-button {\n    color: #6b7280;\n    width: 40px;\n    height: 40px;\n    min-width: 40px;\n    min-height: 40px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.2s ease;\n    background: transparent;\n    border: 1px solid transparent;\n    padding: 0;\n    margin: 0;\n\n    &:hover {\n      background: #f3f4f6;\n      color: #374151;\n      border-color: #e5e7eb;\n    }\n\n    &:active {\n      background: #e5e7eb;\n      transform: scale(0.95);\n    }\n\n    mat-icon {\n      font-size: 20px;\n      width: 20px;\n      height: 20px;\n      line-height: 20px;\n    }\n  }\n}\n\n.dialog-content {\n  padding: 20px 24px !important;\n  max-height: 60vh;\n  overflow-y: auto;\n  box-sizing: border-box;\n}\n\n.form-container {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding: 0;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.image-preview-section {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  margin-bottom: 8px;\n\n  .item-preview-image {\n    width: 100%;\n    max-width: 300px;\n    max-height: 200px;\n    object-fit: contain;\n    border-radius: 8px;\n    border: 1px solid #e4e8f0;\n    background: #f9fafb;\n  }\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n\n  @media (max-width: 480px) {\n    grid-template-columns: 1fr;\n  }\n}\n\n.full-width {\n  width: 100%;\n}\n\n// Ensure proper spacing and padding for Material form fields\n::ng-deep {\n  .item-details-dialog {\n    .mat-form-field {\n      margin-bottom: 0;\n      margin-top: 0;\n      width: 100%;\n    }\n\n    .mat-form-field-wrapper {\n      padding-bottom: 0;\n      margin-bottom: 0;\n    }\n\n    .mat-form-field-appearance-outline {\n      .mat-form-field-infix {\n        padding: 16px 14px !important;\n        min-height: 56px;\n      }\n    }\n  }\n}\n\n.dialog-actions {\n  padding: 20px 24px;\n  border-top: 1px solid #e4e8f0;\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n  align-items: center;\n  margin: 0;\n  min-height: 72px;\n  box-sizing: border-box;\n\n  button {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    padding: 10px 24px;\n    font-size: 14px;\n    font-weight: 500;\n    height: 40px;\n    min-width: 110px;\n    border-radius: 6px;\n    transition: all 0.2s ease;\n    cursor: pointer;\n    box-sizing: border-box;\n    line-height: 1;\n    white-space: nowrap;\n    margin: 0;\n\n    mat-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n      line-height: 18px;\n    }\n  }\n\n  .cancel-btn {\n    color: #6b7280;\n    background: transparent;\n    border: 1px solid #d1d5db;\n\n    &:hover {\n      background: #f9fafb;\n      border-color: #9ca3af;\n      color: #374151;\n    }\n  }\n\n  .save-btn {\n    background: #5ea1d8;\n    color: white;\n    border: 1px solid #5ea1d8;\n\n    &:hover:not(:disabled) {\n      background: #4a8fc4;\n      border-color: #4a8fc4;\n      box-shadow: 0 2px 4px rgba(94, 161, 216, 0.3);\n    }\n\n    &:disabled {\n      opacity: 0.6;\n      cursor: not-allowed;\n      background: #9ca3af;\n      border-color: #9ca3af;\n    }\n  }\n\n  @media (max-width: 768px) {\n    padding: 16px;\n    flex-direction: column-reverse;\n    gap: 12px;\n    min-height: auto;\n\n    button {\n      width: 100%;\n      height: 44px;\n      min-width: unset;\n    }\n  }\n}\n\n// Read-only details view\n.read-only-details {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 16px;\n  background-color: #f9fafb;\n  border-radius: 8px;\n  border: 1px solid #e4e8f0;\n\n  .detail-field {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n\n    label {\n      font-weight: 600;\n      color: #6b7280;\n      font-size: 12px;\n      text-transform: uppercase;\n      letter-spacing: 0.5px;\n    }\n\n    span {\n      color: #111827;\n      font-size: 14px;\n      word-break: break-word;\n    }\n\n    .item-link {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      color: #5ea1d8;\n      text-decoration: none;\n      font-size: 14px;\n      word-break: break-all;\n\n      &:hover {\n        text-decoration: underline;\n      }\n\n      mat-icon {\n        font-size: 18px;\n        width: 18px;\n        height: 18px;\n      }\n    }\n  }\n}\n\n// ── Dark mode overrides ────────────────────────────────────────────────────────\n:host-context(body.theme-dark) {\n  .item-details-dialog {\n    background: #111827;\n    color: #e2e8f0;\n  }\n\n  .dialog-header {\n    background: #111827;\n    border-bottom-color: rgba(148, 163, 184, 0.15);\n\n    h2 {\n      color: #f1f5f9;\n    }\n\n    .close-button {\n      color: #94a3b8;\n\n      &:hover {\n        background: #1f2937;\n        border-color: rgba(148, 163, 184, 0.25);\n        color: #e2e8f0;\n      }\n\n      &:active {\n        background: #374151;\n      }\n    }\n  }\n\n  .dialog-content {\n    background: #111827;\n  }\n\n  .read-only-details {\n    background-color: #1f2937;\n    border-color: rgba(148, 163, 184, 0.15);\n\n    .detail-field {\n      label {\n        color: #94a3b8;\n      }\n\n      span {\n        color: #e2e8f0;\n      }\n    }\n  }\n\n  .image-preview-section .item-preview-image {\n    border-color: rgba(148, 163, 184, 0.2);\n    background: #1f2937;\n  }\n\n  .dialog-actions {\n    background: #111827;\n    border-top-color: rgba(148, 163, 184, 0.15);\n\n    .cancel-btn {\n      color: #94a3b8;\n      border-color: rgba(148, 163, 184, 0.3);\n\n      &:hover {\n        background: #1f2937;\n        border-color: rgba(148, 163, 184, 0.5);\n        color: #e2e8f0;\n      }\n    }\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
